/** Styl autocomplete k tématu Erma */
export const AutocompleteStyles = {
  paddingX: '50%',
  overlay: {
    background: 'var(--erma-primary-0)',
    borderColor: 'var(--erma-secondary-220)',
    borderRadius: 'var(--erma-border-radius-xs)',
    shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)'
  },
  dropdown: {
    width: '3rem',
    sm: {
      width: '2.5rem'
    },
    lg: {
      width: '3.5rem'
    },
    borderColor: 'var(--erma-secondary-220)',
    hoverBorderColor: 'var(--erma-secondary-300)',
    activeBorderColor: 'var(--erma-primary-500)',
    borderRadius: 'var(--erma-border-radius-xs)',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'unset',
      offset: '0',
      shadow: 'none'
    }
  },
  emptyMessage: {
    padding: '.3rem'
  },
  chip: {
    borderRadius: 'var(--erma-border-radius-xs)'
  }
};
